import { watch } from 'vue'
import { useI18n, type LocaleMessages, type VueMessageType } from 'vue-i18n'
import { useLocaleStore } from '@/store/localStore' // Adjust this path accordingly

interface Messages {
  [p: string]: LocaleMessages<VueMessageType>
}

export function useTranslation(messages: Messages) {
  // Access the locale store
  const localeStore = useLocaleStore()

  const { t, locale } = useI18n({
    locale: localeStore.getLocale,
    messages
  })

  // Watch and sync updates to the store locale
  watch(
    () => localeStore.getLocale,
    (newLocale) => {
      locale.value = newLocale
    },
    { immediate: true }
  )

  // Function to change the locale
  const changeLocale = (newLocale: string) => {
    localeStore.setLocale(newLocale as typeof localeStore.locale)
  }

  return { t, locale, changeLocale }
}
